<template>
 <div class="charts-page">
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="$t('iframe.crise.covid19.titulo')"
          :footerText="$t('iframe.crise.covid19.rodape')">
          <iframeBI :fonte='fonte'> </iframeBI>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import iframeBI from '@/components/iframe/implementacoes/iframeBI'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'covid-19',
  components: {
    iframeBI,
    Sp360Panel,
  },
  data: () => ({
    dados: {},
    chartData: {},
    bChartData: {},
    options: {},
    fonte: '',
  }),
  created () {
    this.buscarLinkBi()
  },
  methods: {
    buscarLinkBi () {
       this.$store.dispatch('iframeDashboard/buscarUrlIframe', { nome: constantes.LINK_IFRAME.CRISE.CORONA_VIRUS })
         .then((retorno) => {
           this.fonte = retorno.data.url
         }).catch((error) => {
           console.error(error)
         })
    },
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}
</style>